import GatheringPrivacy from "src/api/graphql/__generated__/enums/GatheringPrivacy";
import { useGatheringStore } from "src/contexts/GatheringContext";
import abbreviateBigNumber from "src/helpers/abbreviateBigNumber";
import IconMessages from "src/icons/IconMessages";
import { Pill } from "src/swsh-native";

const GatheringHomePhotoCommentDisplay = ({ numComments }: { numComments: number }) => {
	const privacy = useGatheringStore((state) => state.privacy);

	if (!privacy?.includes(GatheringPrivacy.EnableComments)) return null;
	return (
		<Pill blur Icon={IconMessages} sizeVariant="sm">
			{abbreviateBigNumber(numComments)}
		</Pill>
	);
};
export default GatheringHomePhotoCommentDisplay;
